import { render } from "./HeaderSub.vue?vue&type=template&id=56dd1e0b&scoped=true"
import script from "./HeaderSub.vue?vue&type=script&lang=js"
export * from "./HeaderSub.vue?vue&type=script&lang=js"

import "@/assets/css/style_header.css?vue&type=style&index=0&id=56dd1e0b&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56dd1e0b"]])

export default __exports__